




















































































































































import mixins from 'vue-typed-mixins';
import * as notificationService from '@/main/utils/notifications';
import { Provozovna } from '@/modules/administrace/provozovna';
import { editFactory } from '@/main/pages';
import { openList } from '@/main/router/routerPath';
import { Dilenske } from '@/modules/ciselnik/dilenske';
import { PracovniPozice } from '@/modules/ciselnik/dilenske/pracovniPozice';
import { TabulkovaPozice } from '@/modules/ciselnik/dilenske/tabulkovaPozice';
import { NakladoveStredisko } from '@/modules/ciselnik/firemni/nakladoveStredisko';
import { Pracovnik } from '@/modules/administrace/pracovnik';
import { ShortcutMixin } from '@/main/mixins/shortcut';
import { EventBus } from '@/main/eventBus';

import { VehicleBrand } from '@/main/components/constants';

import { editMutations, editActions } from './store/types';
import { store } from './store/edit';
import { NAME, SPLIT_PARTY, LABOUR } from './constants';
import { apiProvider, KontrolaGarancePpTzErrorCodes } from './api';
import { POLOZKA_STATUS, ZAKAZKA_DRUH, LINE_ITEM_STATUS, ADDITIONAL_JOB_STATUS, ORDER_SUB_TYPES } from '../constants';
import { NAME as ZAKAZKA_DELBA_PP } from './delba/constants';
import { splitValidationCheck } from '../utils';

export default mixins(editFactory(NAME, store), ShortcutMixin).extend({
	components: {
		TabulkovaPoziceSelect: TabulkovaPozice.components.Select,
		NakladoveStrediskoSelect: NakladoveStredisko.components.Select,
		PracovnikSelect: Pracovnik.components.Select,
		PpNrSelect: Dilenske.components.PpNrSelect,
		PpDescSelect: Dilenske.components.PpDescSelect,
	},
	data() {
		return {
			enableCasJdnPoc: false,
			enableLakJdnPoc: false,
			enableDphSzbOzn: false,
			showDialog: false,
			saga2Disablefields: false,
			isJobStatusPending: false,
			isPendingStatusOther: false,
		};
	},
	watch: {
		SplitParty() {
			if (!this.isCustomerShareVisible) {
				this.CustomerShareValue = null;
			}
			if (!this.isInsShareVisible) {
				this.InsuranceShareValue = null;
			}
			if (!this.isGoodwillShareVisible) {
				this.GoodwillShareValue = null;
			}
		},
		ppNr: {
			immediate: true,
			handler() {
				if (!this.enableCasJdnPoc) {
					this.enableCasJdnPoc = this.isVolnaNecenikovaPP;
				}
				if (!this.enableLakJdnPoc) {
					this.enableLakJdnPoc = this.isVolnaNecenikovaPPLakJdnPoc;
				}
				if (!this.enableDphSzbOzn) {
					this.enableDphSzbOzn = (this.enableCasJdnPoc || this.enableLakJdnPoc);
				}
			},
		},
	},
	computed: {
		isCustomerShareVisible(): boolean {
			return this.SplitParty.includes(SPLIT_PARTY.CUSTOMER);
		},
		isInsShareVisible(): boolean {
			return this.SplitParty.includes(SPLIT_PARTY.INSURANCE);
		},
		isGoodwillShareVisible(): boolean {
			return this.SplitParty.includes(SPLIT_PARTY.GOODWILL);
		},
		mutationsMappers() : Record<string, string> {
			return {
				ppnr: `${this.storeUri}/${editMutations.PRACOVNI_POZICE_PPNR_SELECT_MAPPER}`,
				tablpoz: `${this.storeUri}/${editMutations.PRACOVNI_POZICE_TABLPOZ_SELECT_MAPPER}`,
				pracovnik: `${this.storeUri}/${editMutations.PRACOVNIK_SELECT_MAPPER}`,
			};
		},
		actionsMapper() : Record<string, string> {
			return {
				nakladoveStredisko: `${this.storeUri}/${editActions.NAKLADOVE_STREDISKO_MAPPER}`,
				laborPrice: `${this.storeUri}/${editActions.LABOR_PRICE_MAPPER}`,
			};
		},
		ppServiceNrFilter() : Record<string, any> {
			return {
				VyrobekvozOzn: this.VyrobekvozOzn,
				Tablpozice: this.Tablpozice,
				// PpNr rozsiruje PpServiceNr kde prvni 4 cisla urcuji PpServiceNr servisni cinost a PpNr druh cinosti
				PpNr: this.PpNr ? this.PpNr.substring(0, 4) : null,
				Text: this.Text,
			};
		},
		ppDruhFilter() : Record<string, any> {
			return {
				VyrobekvozOzn: this.VyrobekvozOzn,
				Tablpozice: this.Tablpozice,
				PpServisNr: this.PpNr ? this.PpNr.substring(0, 4) : null,
				Text: this.Text,
			};
		},
		pracovniPoziceFilter() : Record<string, any> {
			let ppType = PracovniPozice.ppFilterEnum.DEFAULT;
			if (this.PpNekonPrp) {
				ppType = PracovniPozice.ppFilterEnum.NEKONCERNOVE;
			}
			if (this.PpNr && (this.PpNr.startsWith('99') || this.PpNr.startsWith('98'))) {
				ppType = PracovniPozice.ppFilterEnum.VOLNE_NEKONCERNOVE;
			}
			if (this.SdaPp) {
				ppType = PracovniPozice.ppFilterEnum.SDA;
			}
			return {
				VyrobekvozOzn: this.VyrobekvozOzn,
				PpNr: this.PpNr,
				Tablpozice: this.Tablpozice,
				TablpoziceText: this.TablpoziceText,
				Type: ppType,
				KaroserieNr: this.props?.filter?.KaroserieNr ?? null,
				Text: this.Text,
			};
		},
		isActivityEnded() : boolean | null {
			return this.IsEligibleForCompletion;
		},
		isEdit1() : boolean {
			return this.EditPrp === 1;
		},
		isEdit2() : boolean {
			return this.EditPrp === 2;
		},
		isEdit1Or2() : boolean {
			return this.isEdit1 || this.isEdit2;
		},
		isTextEnabled() : boolean {
			return (this.TextEnabled || this.isEdit1Or2) || this.isVolnaNecenikovaPP;
		},
		isPpServisNrDruhDisabled(): boolean {
			return !this.isEditMode || (this.isCreateMode && this.ZakazkaDruh === ZAKAZKA_DRUH.DROBNE_SLUZBY);
		},
		isNekoncernovePpDisabled() : boolean {
			return !(this.IsKoncernoveVozidlo && this.VyrobekvozOzn !== 'C') || this.IsKoncernoveVozidlo;
		},
		isPcPevnaEnabled(): boolean {
			return !!this.FlagZmenaPcFix && this.ZakazkaDruh !== ZAKAZKA_DRUH.GARANCE && !this.SnPp;
		},
		isPpCheckEnabled() : boolean {
			return !this.isCreateMode && !!this.PpNr && this.PpNr.length > 1 && !!this.PpCheckEnabled;
		},
		isPcSpecEnabled(): boolean {
			return (this.FlagZmenaPcSpec && this.ZakazkaDruh !== ZAKAZKA_DRUH.GARANCE) || this.isVolnaNekoncernovaPP;
		},
		isVolnaNekoncernovaPP() : boolean {
			return Boolean(this.PpNr) && (this.PpNr!.startsWith(PracovniPozice.ppPrefix.PPNR_VOLNA1) || this.PpNr!.startsWith(PracovniPozice.ppPrefix.PPNR_VOLNA2));
		},
		isVolnaNecenikovaPP() : boolean {
			return Boolean(this.CasJdnPoc) && (this.CasJdnPoc!.toString().endsWith('99') || this.CasJdnPoc!.toString().endsWith('98'));
		},
		isVolnaNecenikovaPPLakJdnPoc() : boolean {
			return Boolean(this.LakJdnPoc) && (this.LakJdnPoc!.toString().endsWith('99') || this.LakJdnPoc!.toString().endsWith('98'));
		},
		isSlevaEnabled(): boolean {
			return !!this.FlagZmenaSlevaZvlastni && this.ZakazkaDruh !== ZAKAZKA_DRUH.GARANCE && !this.SnPp;
		},
		ppNekonPrpLabel() : string {
			return this.VyrobekvozOzn === VehicleBrand.SKODA ? 'NekoncSkoda' : 'PPNEKON_PRP';
		},
		isSkoda105120() : boolean {
			return this.VyrobekvozOzn === VehicleBrand.SKODA && !!this.PpNekonPrp;
		},
		isPpButtonDisabled() : boolean {
			return !this.SdaPp && (!this.PpNr || this.PpNr.length < 2) && !this.isSkoda105120 && !this.PpNekonPrp;
		},
		loggedUser(): any {
			return this.$store.state.loggedUser;
		},
		isJobStatusDisabled() : boolean {
			return ![ORDER_SUB_TYPES.BODY_SHOP_REPAIR, ORDER_SUB_TYPES.PDI, ORDER_SUB_TYPES.PDI_BODY_SHOP_C, ORDER_SUB_TYPES.BODY_PAINT_V,
				ORDER_SUB_TYPES.PDI_V, ORDER_SUB_TYPES.BODY_PAINT_A, ORDER_SUB_TYPES.PDI_A, ORDER_SUB_TYPES.PDI_S].includes(this.OrderSubtypeId);
		},
	},
	methods: {
		async onDiscountChange() {
			if (this.dmsSys.OrderDiscountPrp && (this.Sleva !== null && this.DiscountVal !== null)) {
				if (this.VyrobekvozOzn !== VehicleBrand.SKODA) {
					this.showErrorAlert({ message: 'anyOneTypeDiscountAllowed' });
				} else {
					const isValid = await this.showConfirmPokracovat('bothDiscountMessage');
					if (isValid) return;
				}
				this.Sleva = null;
				this.DiscountVal = null;
			}
		},
		async loadedData() {
			this.fetchTableSchemas();
			this.fetchTableData();
			if (this.LineItemStatusId === LINE_ITEM_STATUS.JOB_NOT_COMPLETE_BEFORE_DELIVERY) {
				this.isJobStatusPending = true;
				if (this.LineItemStatusPendingReasonId === LINE_ITEM_STATUS.OTHER) {
					this.isPendingStatusOther = true;
				}
			} else {
				this.isJobStatusPending = false;
			}
			if (this.isEditMode) {
				this.selectedPracovniPozice = true;
			}
			if (this.props.saga2Status) {
				EventBus.$emit('DisableAll', true);
				this.saga2Disablefields = true;
			}
			if (this.props.saga2Status === POLOZKA_STATUS.ZAMITNUTO) {//REJECTED
				this.operations = 1;
				this.SagaItemStatus = POLOZKA_STATUS.ZAMITNUTO;
			}
			if (this.props.saga2Status === POLOZKA_STATUS.ZMENA) {//EDIT
				this.CasJdnPoc = Number(this.props.mnozstvi);
				this.operations = 1;
				this.SagaItemStatus=POLOZKA_STATUS.ZMENA;
			}
			if (this.props.saga2Status === POLOZKA_STATUS.NAVRH) {//Proposal
				this.UpravaS2 = true;
				this.NavrhPolId = this.props.polozkaId;
				this.PpNr = this.props.polozkaNr;
				this.ZarmobilPzn = this.props.zarmobilPzn;
				this.Text = this.props.polozkaText;
				this.DphSzbOzn = this.props.dphSzbOzn;
				this.LakJdnPoc = Number(this.props.lakJdnPoc);
				this.StrednaklOzn = this.props.strnakltypOzn !== -1 ? this.props.strnakltypOzn : null; // TODO: minus -1 je naprd je potreba to zmenit na BE
				this.PcPevna = this.props.pcPevna;
				if (this.props.casJdnPoc !== -1) {
					this.CasJdnPoc = this.props.casJdnPoc;
				} else {
					this.CasJdnPoc = 99999; // podle dms asi znamena ze je nutna editace zjistim
					this.enableCasJdnPoc = true;
				}
				this.SagaItemStatus=POLOZKA_STATUS.NAVRH;
			}
		},
		keyboardShortcutsHandler(shortcut: Record<string, any>) {
			if (shortcut.key === 'Enter' && this.PpNr && this.PpNr.length >= 2) {
				if (!this.selectedPracovniPozice) {
					(this.$refs.ppNrSelect as HTMLFormElement).$refs.selectButton.clickEvent();
				} else {
					(this.$refs.editLayout as HTMLFormElement).$refs.addButton.clickEvent();
				}
			}
		},
		onVyrobekvozOznChange() {
			this.Tablpozice = null;
			this.TablpoziceText = null;
		},
		onLakJdnPocChange() {
			if (!this.CasJdnPoc) {
				this.LakdruhId = null;
			}
		},
		onRozpracovanostClick() {
			openList(ZAKAZKA_DELBA_PP, {
				filter: {
					PpId: this.PpId,
				},
				SumaCj: this.CasJdnPoc,
			});
		},
		async pracovniPoziceCheck() {
			if (!this.TzPp) {
				// this.checkPp(
				// 	this.VyrobekvozOzn,
				// 	this.Tablpozice,
				// 	this.PpNrt,
				// 	this.PpId,
				// 	this.SdaPp ? this.ZakazkaVozidloKaroserieNr : null,
				// 	this.SdaPp,
				// 	this.kSnPp,
				// 	this.NekoncernovePp,
				// );
				return true;
			}

			const provozovna = (await Provozovna.apiProvider.entity(this.loggedUser.UzivatelData.ProvozovnaId)).data;

			const result = (await apiProvider.kontrolaGarancePpTz(this.VyrobekvozOzn!, this.Tablpozice!, this.ZakazkaVozidloTypkod!, this.PpNr!,
				provozovna.SkodanrKonPrp)).data;

			let chyba;
			switch (result) {
				case KontrolaGarancePpTzErrorCodes.NeznamaChybaVSP:
					chyba = 'ZakazkappExcGar';
					break;
				case KontrolaGarancePpTzErrorCodes.NepripustnyKodZavadyVPP:
					chyba = 'ZakazkappErrCin';
					break;
				case KontrolaGarancePpTzErrorCodes.NepripustnyDruhCinnostiVPP:
					chyba = 'ZakazkappErrDruh';
					break;
				case KontrolaGarancePpTzErrorCodes.Moznost2:
					// this.checkPP(
					// 	this.VyrobekvozOzn,
					// 	this.Tablpozice,
					// 	this.PpNr,
					// 	this.PpId,
					// 	this.ZakazkaVozidloTypkod,
					// 	this.SdaPp,
					// 	this.kSnPp,
					// 	this.NekoncernovePp,
					// );
					return true;
				case KontrolaGarancePpTzErrorCodes.NepripustnaKombinaceVPPNaPozici7Az8:
					chyba = 'ZakazkappErrKomb';
					break;
				case KontrolaGarancePpTzErrorCodes.Moznost4:
					this.PpCheckEnabled = true;
					this.DphSzbOznEnabled = false;
					this.TextEnabled = false;
					this.Text = (await PracovniPozice.apiProvider.getTextPpTz(this.VyrobekvozOzn!, this.PpNr!, this.Tablpozice!)).data;

					this.PpTzPriv = true;
					break;
				default:
					break;
			}

			if (chyba) {
				chyba = this.LocalizeChyboveHlasky(chyba);
				await notificationService.showAlert({ message: chyba });
			}
			return false;
		},
		onSdaPpClick() {
			if (this.SdaPpEnabled && this.SdaPp) {
				if (this.TzPpEnabled) this.TzPp = false;
				if (this.SnPpEnabled) this.SnPp = false;
			}
		},
		onSnPpClick() {
			if (this.SnPpEnabled && this.SnPp) {
				if (this.TzPpEnabled) this.TzPp = false;
				if (this.SdaPpEnabled) this.SdaPp = false;
			}
		},
		onTzPpClick() {
			if (this.TzPpEnabled && this.TzPp) {
				if (this.SdaPpEnabled) this.SdaPp = false;
				if (this.SnPpEnabled) this.SnPp = false;
			}
		},
		onPcPevnaChange() {
			if (this.PcPevna) {
				this.Sleva = null;
				this.PcSpec = null;
			}
		},
		onSlevaChange() {
			if (this.Sleva) {
				this.PcPevna = null;
			}
		},
		onProvozovnaIdChange() {
			this.StrednaklOzn = null;
			this.StrednaklOznText = null;
		},

		async saveClick() {
			if (this.dmsSys.WorkItemPrp) {
				if (this.IsEligibleForCompletion && this.LineItemStatusId === null) {
					this.showErrorAlert({ message: 'JobStatusRequired' });
					return;
				}
				if (this.LineItemStatusId === LINE_ITEM_STATUS.JOB_NOT_COMPLETE_BEFORE_DELIVERY
				&& (this.LineItemStatusPendingReasonId === LINE_ITEM_STATUS.NOT_SELECTED || this.LineItemStatusPendingReasonId === null)) {
					this.showErrorAlert({ message: 'PendingReasonRequired' });
					return;
				}
				if (this.isPendingStatusOther && (this.LineItemStatusPendingRemarksOthers === null || this.LineItemStatusPendingRemarksOthers.trim() === '')) {
					this.showErrorAlert({ message: 'LineStatusRemarksRequired' });
					return;
				}
				if (this.dmsSys.SplitPrp && (this.SplitBy || this.SplitParty.length > 0)) {
					const objSplitValidation = splitValidationCheck(this.edit);
					if (!objSplitValidation.isValid) {
						this.showErrorAlert({ message: this.LocalizeChyboveHlasky(objSplitValidation.validateMessage) });
						return;
					}
				}
			}
			if (this.dmsSys.EnableGSTPrp) {
				this.ZarmobilPzn = 1;			
				this.EmisePzn = 1;
			}
			this.StrnakltypOznOrig = 1;

			if (this.LakJdnPoc! > 0 && !this.LakdruhId) {
				this.showDialog = true;
			} else {
				this.startLoading();
				await apiProvider.setResetAdditionalJobStatus(this.PpId, ADDITIONAL_JOB_STATUS.ADDITIONAL);
				await apiProvider.sendEmailAndSmsNotificationPPID(this.PpId);
				await this.save();
				this.endLoading();
			}
		},
		onUpdatePendingReason(val: number | null) {
			this.isPendingStatusOther = Number(val) === LINE_ITEM_STATUS.OTHER;
		},
		onUpdateJobStatus(val: number | null) {
			this.isJobStatusPending = Number(val) === LINE_ITEM_STATUS.JOB_NOT_COMPLETE_BEFORE_DELIVERY;
		},
		async addPracovniPozice() {
			if (this.LakJdnPoc! > 0 && !this.LakdruhId) {
				this.showDialog = true;
			} else {
				this.startLoading();
				await apiProvider.createPracovniPozice(this.edit);
				(this.$refs.ppNrSelect as any).focusInput();
				this.selectedPracovniPozice = false;
				this.PpNr = null;
				this.Text = null;
				this.CasJdnPoc = 0;
				this.refreshPreviousPage = true;
				this.$nextTick(() => (this.$refs.editLayout as any).mainForm.clearValidate('PpNr'));
				this.endLoading();
			}
		},
		checkPp(
			vyrobekvozOzn: string, tablpozice: string, ppNrt: string, ppId: number, karoserieNr: string, sdaPp: boolean, snPp: boolean, nekoncernovePp: boolean,
		) {
			// Toto je povodne volanie filtru PP, priĝom na filtru  sa robili este pokrocile nastavenia a vyhodnocovanie karoserie, ..., ktore mozno nebudu treba.
			// Nechavam to tu pre pripad, ze sa to v buducnosti bude chciet dorabat, aby to nemusel niekto znovu analyzovat
			// Ak by sa to malo pouzit, tak sa iba filter PP rozsiruje o dodatocne parametre a na servru sa tieto udaje vyhodnotia.
			// Ale mozno to uz nebude treba a bolo to iba v DMS2 nutne takto robit
		}
	},
});
